export type ImagePluginId = 'camera';

export type ImagePluginMeta = {
  id: ImagePluginId;
  label: string;
};

const REGISTRY: Record<ImagePluginId, ImagePluginMeta> = {
  camera: { id: 'camera', label: '摄像机控制' },
};

export function getImagePluginMeta(id: string): ImagePluginMeta | null {
  return (REGISTRY as any)?.[id] ?? null;
}

export function normalizeImagePlugins(input: unknown): ImagePluginId[] {
  if (!Array.isArray(input)) return [];
  const out: ImagePluginId[] = [];
  for (const v of input) {
    if (typeof v !== 'string') continue;
    const meta = getImagePluginMeta(v);
    if (meta) out.push(meta.id);
  }
  return Array.from(new Set(out));
}


